var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.extras &&
    _vm.extras.groupFooterDisplay &&
    _vm.extras.groupFooterDisplay.display == 1
  )?_c('div',{staticClass:"m-pc-footer new",style:({
    background:
      _vm.extras.footerBg.colorOrBg == 'color'
        ? _vm.extras.footerBg.color
        : 'url(' + _vm.extras.footerBg.src + ')',
  })},[_c('div',{staticClass:"top-nav"},[_c('div',{staticClass:"footer-inner"},[_c('div',{staticClass:"_left"},[_c('div',{staticClass:"top"},[_c('div',{staticClass:"logo-img"},[(_vm.extras.footerLogo.display)?_c('img',{attrs:{"src":_vm.extras.footerLogo.src,"alt":""}}):_vm._e()]),_c('div',{staticClass:"content"},[(_vm.extras.footerTextStyle.title != 'hide')?_c('div',{staticClass:"title",style:({
                color:
                  _vm.extras.footerTextStyle.title == 'custom'
                    ? _vm.extras.footerTextStyle.fontColor
                    : '',
                'font-size':
                  _vm.extras.footerTextStyle.title == 'custom'
                    ? _vm.extras.footerTextStyle.fontSize + 'px'
                    : '',
                'font-style':
                  _vm.extras.footerTextStyle.title == 'custom'
                    ? _vm.extras.footerTextStyle.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  _vm.extras.footerTextStyle.title == 'custom'
                    ? _vm.extras.footerTextStyle.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              })},[_vm._v(" "+_vm._s(_vm.extras.contact.model || "联系我们")+" ")]):_vm._e(),(_vm.extras.footerTextStyle.content != 'hide')?_c('div',{style:({
                color:
                  _vm.extras.footerTextStyle.content == 'custom'
                    ? _vm.extras.footerTextStyle.fontColor2
                    : '',
                'font-size':
                  _vm.extras.footerTextStyle.content == 'custom'
                    ? _vm.extras.footerTextStyle.fontSize2 + 'px'
                    : '',
                'font-style':
                  _vm.extras.footerTextStyle.content == 'custom'
                    ? _vm.extras.footerTextStyle.fontTilt2 == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-Weight':
                  _vm.extras.footerTextStyle.content == 'custom'
                    ? _vm.extras.footerTextStyle.fontWeight2 == 'on'
                      ? 'bolder'
                      : ''
                    : '',
              })},[_vm._v(" "+_vm._s(_vm.extras.content.model || "合作联系 xxx.xxx@outlook.com")+" ")]):_vm._e()])]),(_vm.extras.footerTextStyle.copyright != 'hide')?_c('div',{staticClass:"bottom",style:({
            color:
              _vm.extras.footerTextStyle.copyright == 'custom'
                ? _vm.extras.footerTextStyle.fontColor3
                : '',
            'font-size':
              _vm.extras.footerTextStyle.copyright == 'custom'
                ? _vm.extras.footerTextStyle.fontSize3 + 'px'
                : '',
            'font-style':
              _vm.extras.footerTextStyle.copyright == 'custom'
                ? _vm.extras.footerTextStyle.fontTilt3 == 'on'
                  ? 'italic'
                  : 'normal'
                : '',
            'font-Weight':
              _vm.extras.footerTextStyle.copyright == 'custom'
                ? _vm.extras.footerTextStyle.fontWeight3 == 'on'
                  ? 'bolder'
                  : ''
                : '',
          })},[_c('div',[_vm._v(" "+_vm._s(_vm.extras.copyright.model || "Copyright ©2023 All rights reserved.")+" ")])]):_vm._e()]),_c('div',{staticClass:"qr-code"},[(_vm.extras.qrcode.display)?_c('img',{attrs:{"src":_vm.extras.qrcode.src,"alt":""}}):_vm._e()])])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }